<template>
  <v-row class="px-md-16 my-16" justify="center">
    <v-col cols="12" md="5" v-if="content.title || content.description">
      <h2 class="text-h4 mb-16">{{content.title}}</h2>
      <MarkdownBlock v-if="content.description" :text="content.description" class="text-body-1" />
    </v-col>
    <v-col cols="12" md="7" class="perspective-container">
      <v-responsive :aspect-ratio="16/9" :style="momentumRotationStyle(momentum)">
        <iframe v-if="content.vogueVideo" scrolling="no" :src="`https://player.cnevids.com/iframe/video/${content.vogueVideo.videoID}.js?autoplay=0&muted=0&continuousPlay=0&showPlaylistBar=0&adsDisabled=1&hasCompanion=0&analyticsUrl=${content.vogueVideo.analyticsUrl}`" allowfullscreen webkitallowfullscreen mozallowfullscreen frameBorder="0" width="100%" height="100%" />
        <VuePlyr v-else><div :data-plyr-provider="videoInfo.service" :data-plyr-embed-id="videoInfo.id" /></VuePlyr>
      </v-responsive>
    </v-col>
  </v-row>
</template>

<script>
import MarkdownBlock from '@monogrid/vue-lib/lib/components/MarkdownBlock'
import MomentumRotation from '@/mixins/momentum-rotation.js'

import getVideoId from 'get-video-id'
import VuePlyr from 'vue-plyr'
import 'vue-plyr/dist/vue-plyr.css'

export default {
  name: 'InitiativeVideo',
  mixins: [MomentumRotation],
  props: {
    content: {
      type: Object,
      required: true
    },
    momentum: {
      type: Number,
      required: false,
      default () {
        return 0
      }
    },
    index: {
      type: Number,
      required: false,
      default () {
        return 0
      }
    }
  },
  components: {
    VuePlyr,
    MarkdownBlock
  },
  methods: {
    getVideoId
  },
  computed: {
    videoInfo () {
      return getVideoId(this.content.video)
    }
  }
}
</script>
